import {
  AfterContentInit,
  Directive,
  ElementRef,
  Input,
  OnInit,
} from '@angular/core';

@Directive({
  selector: '[appFocus]',
})
export class FocusDirective implements OnInit, AfterContentInit {
  @Input('appFocus') isFocused: boolean = false;

  constructor(private hostElement: ElementRef) {}

  ngOnInit() {}
  public ngAfterContentInit() {
    setTimeout(() => {
      if (this.isFocused) {
        this.hostElement.nativeElement.focus();
      }
    }, 500);
  }
}
